import * as api from '../api/interactions';
import q from '../query';
const emailServerKey = (id) => `email-server-${id}`;
export const useEmailServer = (id) => q.query(emailServerKey(id), () => (id ? api.getEmailServer(id) : null), [], {
    enabled: id != null,
});
//# sourceMappingURL=index.js.map